import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const tokensList = (params = '') => Http.get(`/admin/configs${serialize(params)}`)
export const tokenByID = (params = '') => Http.get(`/admin/configs${params}`)
export const tokenUpdate = (params = '') => Http.put(`/admin/configs/${params.id}`, params)
